import { TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA, XLAYER_USDC_ALLOWANCE_OWNER, XLAYER_USDC_ALLOWANCE_SPENDER, } from "../fixture-inputs.js";
// Bridged USDC.e on X Layer — the canonical stablecoin used for contract-call
// shaped tests on this chain.
const XLAYER_USDC = "0x74b7F16337b8972027F6196A17a631aC6dE26d22";
export const XLAYER_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getBlockByNumberXlayer",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getBalanceXlayer",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: XLAYER_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getTokenBalanceXlayer",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.xlayer,
        fixture: "getBlockByHashXlayer",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getBlockTransactionsXlayer",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getTransfersXlayer",
    },
    simulateCallQuery: {
        to: XLAYER_USDC,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "simulateCallXlayer",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.xlayer,
        fixture: "traceTransactionXlayer",
    },
    tokenMetadataQuery: {
        address: XLAYER_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getTokenMetadataXlayer",
    },
    tokenAllowanceQuery: {
        token: XLAYER_USDC,
        owner: XLAYER_USDC_ALLOWANCE_OWNER,
        spender: XLAYER_USDC_ALLOWANCE_SPENDER,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getTokenAllowanceXlayer",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.xlayer,
        fixture: "getReceiptXlayer",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.xlayer,
        fixture: "getTransactionByHashXlayer",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasXlayer",
    },
    codeQuery: {
        address: XLAYER_USDC,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.xlayer,
        fixture: "getCodeXlayer",
    },
    logsQuery: {
        // X Layer USDC.e — 50-block window for log density.
        address: XLAYER_USDC,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.xlayer - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.xlayer),
        fixture: "getLogsXlayer",
    },
};
